// src/components/WhatsAppFloat.tsx - Sağ Alt Köşe WhatsApp Butonu

import React, { useState } from 'react'
import { MessageCircle, Users, X } from 'lucide-react'

// WhatsApp SVG Icon
const WhatsAppIcon = ({ className = "w-6 h-6" }: { className?: string }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
  </svg>
)

export default function WhatsAppFloat() {
  const [isOpen, setIsOpen] = useState(false)

  const handleWhatsAppGroup = () => {
    window.open('https://chat.whatsapp.com/G3OgMNj8vSfErXtw3k23bQ', '_blank')
    setIsOpen(false)
  }

  const handleWhatsAppDirect = () => {
    const message = encodeURIComponent('Merhaba, EarnBackHub hakkında bilgi almak istiyorum')
    window.open(`https://wa.me/+908503039389?text=${message}`, '_blank')
    setIsOpen(false)
  }

  return (
    <div className="fixed bottom-6 right-6" style={{ zIndex: 9999 }}>
      {/* Menü - Yukarıda açılır */}
      {isOpen && (
        <div className="absolute bottom-20 right-0 mb-2 w-64 bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden animate-slideUp">
          {/* Header */}
          <div className="bg-gradient-to-r from-green-500 to-emerald-600 p-4 text-white">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <WhatsAppIcon className="w-6 h-6" />
                <h3 className="font-bold text-lg">WhatsApp</h3>
              </div>
              <button
                onClick={() => setIsOpen(false)}
                className="hover:bg-white/20 rounded-full p-1 transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            <p className="text-sm text-green-50 mt-1">Nasıl yardımcı olabiliriz?</p>
          </div>

          {/* Menü Seçenekleri */}
          <div className="p-3 space-y-2">
            {/* Gruba Katıl */}
            <button
              onClick={handleWhatsAppGroup}
              className="w-full flex items-center gap-3 p-3 hover:bg-green-50 rounded-xl transition-all duration-200 group border border-transparent hover:border-green-200"
            >
              <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center group-hover:bg-green-200 transition-colors">
                <Users className="w-5 h-5 text-green-600" />
              </div>
              <div className="flex-1 text-left">
                <div className="font-semibold text-gray-800 text-sm">Gruba Katıl</div>
                <div className="text-xs text-gray-500">Topluluğumuza katılın</div>
              </div>
              <svg className="w-4 h-4 text-gray-400 group-hover:text-green-600 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>

            {/* Özelden Mesaj */}
            <button
              onClick={handleWhatsAppDirect}
              className="w-full flex items-center gap-3 p-3 hover:bg-green-50 rounded-xl transition-all duration-200 group border border-transparent hover:border-green-200"
            >
              <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center group-hover:bg-green-200 transition-colors">
                <MessageCircle className="w-5 h-5 text-green-600" />
              </div>
              <div className="flex-1 text-left">
                <div className="font-semibold text-gray-800 text-sm">İletişime Geç</div>
                <div className="text-xs text-gray-500">Direkt mesaj gönderin</div>
              </div>
              <svg className="w-4 h-4 text-gray-400 group-hover:text-green-600 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>

          {/* Footer */}
          <div className="px-4 py-3 bg-gray-50 border-t border-gray-200">
            <p className="text-xs text-gray-600 text-center">
              7/24 destek için buradayız
            </p>
          </div>
        </div>
      )}

      {/* Ana WhatsApp Butonu */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`relative w-16 h-16 rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 ${
          isOpen 
            ? 'bg-gray-600 hover:bg-gray-700 rotate-0' 
            : 'bg-green-600 hover:bg-green-700 hover:scale-110'
        }`}
        style={{ zIndex: 10000 }}
        aria-label="WhatsApp İletişim"
      >
        {isOpen ? (
          <X className="w-7 h-7 text-white" />
        ) : (
          <WhatsAppIcon className="w-8 h-8 text-white" />
        )}
      </button>

      {/* Inline Styles for Animations */}
      <style dangerouslySetInnerHTML={{
        __html: `
          @keyframes slideUp {
            from {
              opacity: 0;
              transform: translateY(10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          .animate-slideUp {
            animation: slideUp 0.3s ease-out;
          }
        `
      }} />
    </div>
  )
}